import en from './locale/en';
import zh_CN from './locale/zh_CN';

export default {
  en,
  zh_CN,
};
